import { render, staticRenderFns } from "./Monitor.html?vue&type=template&id=23042bb8&scoped=true&external"
import script from "./Monitor.vue?vue&type=script&lang=js"
export * from "./Monitor.vue?vue&type=script&lang=js"
import style0 from "./Monitor.scss?vue&type=style&index=0&id=23042bb8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23042bb8",
  null
  
)

export default component.exports